"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBase64FromFile = void 0;
const getBase64FromFile = (file) => {
    if (!file || typeof file === "string") {
        return null;
    }
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => {
            reject(error);
        };
    });
};
exports.getBase64FromFile = getBase64FromFile;
